/** @jsx jsx */
import { jsx } from "frontend/src/utils/jsx"
import { SectionGrid, Grid } from "frontend/src/components/Layout"
import { Fragment } from "react"

function SingleReviewLP({ review, fiveStars }) {
  const { title, content, customer } = review
  return (
    <Fragment>
      <SingleReviewDesktop
        title={title}
        content={content}
        customer={customer}
        fiveStars={fiveStars}
      />
      <SingleReviewMobile
        title={title}
        content={content}
        customer={customer}
        fiveStars={fiveStars}
      />
    </Fragment>
  )
}

function SingleReviewDesktop({ title, content, customer, fiveStars }) {
  return (
    <div
      sx={{
        height: ["unset", "unset", "30vw", "360px"],
        display: ["none", "none", "block"],
        backgroundColor: "rgb(240,243,245)",
        position: "relative",
        py: 6,
        px: 5,
      }}
    >
      <h4
        sx={{
          fontFamily: "body",
          fontWeight: 700,
          fontSize: ["unset", "unset", "1.317631vw", "15.8512px"],
          lineHeight: ["unset", "unset", "1.579375vw", "19px"],
        }}
      >
        {title}
      </h4>
      <div
        sx={{
          height: ["unset", "unset", "1.33vw", "16px"],
          width: ["unset", "unset", "7.81375vw", "94px"],
          my: 5,
        }}
      >
        <img src={fiveStars} alt="five stars" sx={{ width: "100%" }} />
      </div>
      <p
        sx={{
          fontSize: ["unset", "unset", "1.317631vw", "15.8512px"],
          lineHeight: ["unset", "unset", "2.16125vw", "26px"],
          fontStyle: "italic",
          fontWeight: 400,
          fontFamily: "body",
        }}
      >
        {content}
      </p>
      <h5
        sx={{
          fontFamily: "body",
          fontWeight: 700,
          fontSize: ["unset", "unset", "1.152977vw", "13.8704px"],
          lineHeight: ["unset", "unset", "1.413125vw", "17px"],
          position: "absolute",
          bottom: 5,
        }}
      >
        {customer}
      </h5>
    </div>
  )
}

function SingleReviewMobile({ title, content, customer, fiveStars }) {
  return (
    <div
      sx={{
        width: ["86vw", "344px", "unset"],
        height: ["98.25vw", "393px", "unset"],
        display: ["block", "block", "none"],
        mx: "auto",
        backgroundColor: "rgb(240,243,245)",
        py: 6,
      }}
    >
      <div sx={{ width: ["69.75vw", "279px", "unset"], mx: "auto" }}>
        <div
          sx={{
            fontSize: ["4.4452vw", "17.7808px", "unset"],
            lineHeight: ["6.2816vw", "25.1264px", "unset"],
            textAlign: "center",
            color: "#37465a",
          }}
        >
          <h4
            sx={{
              textAlign: "center",
              fontFamily: "body",
              fontWeight: 700,
              fontSize: ["4.4452vw", "17.7808px", "unset"],
              lineHeight: ["6vw", "24px", "unset"],
            }}
          >
            {title}
          </h4>
        </div>
        <div
          sx={{
            height: ["4.5vw", "18px", "unset"],
            width: ["26.75vw", "107px", "unset"],
            mx: "auto",
            textAlign: "center",
            my: 6,
          }}
        >
          <img src={fiveStars} alt="five stars" sx={{ width: "100%", height: "100%" }} />
        </div>
        <div
          sx={{
            color: "#37465a",
            fontSize: ["4.4464vw", "17.7856px", "unset"],
            lineHeight: ["7.1812vw", "28.7248px", "unset"],
            textAlign: "center",
          }}
        >
          <p
            sx={{
              fontFamily: "body",
              fontWeight: 400,
              fontSize: ["4.4464vw", "17.7856px", "unset"],
              lineHeight: ["6.75vw", "27px", "unset"],
              fontStyle: "italic",
            }}
          >
            {content}
          </p>
        </div>
        <div
          sx={{
            height: ["4.5vw", "18px", "unset"],
            width: ["46.5vw", "186px", "unset"],
            fontSize: ["3.8908vw", "15.5632px", "unset"],
            lineHeight: ["4.7128vw", "18.7648px", "unset"],
            textAlign: "center",
            fontWeight: 700,
            mx: "auto",
          }}
        >
          <h5
            sx={{
              fontFamily: "body",
              fontWeight: 700,
              mt: ["3vw", "12px", "unset"],
              textAlign: "center",
              lineHeight: ["4.5vw", "18px", "unset"],
            }}
          >
            {customer}
          </h5>
        </div>
      </div>
    </div>
  )
}

function ReviewsLandingpage({ title, fiveStars, reviews }) {
  return (
    <SectionGrid sx={{ my: "25px" }}>
      <SectionGrid.narrow>
        <h3
          sx={{
            textAlign: "center",
            fontFamily: "body",
            fontWeight: 700,
            mb: 5,
            fontSize: ["5.4488vw", "21.7952px", "2.470608vw", "21.7952px"],
            lineHeight: ["7.75vw", "31px", "2.9925vw", "31px"],
          }}
        >
          {title}
        </h3>
        <Grid columns={["1fr", "1fr", "1fr 1fr 1fr"]} gap="40px">
          {reviews.map((review, index) => (
            <SingleReviewLP key={index} review={review} fiveStars={fiveStars} />
          ))}
        </Grid>
      </SectionGrid.narrow>
    </SectionGrid>
  )
}

export { ReviewsLandingpage }
